(() => {
  if (customElements.get('fd-winter-bundle')) return;
  class WinterBundle extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.products = this.collectionProducts(JSON.parse(this.querySelector('[data-products]').textContent));
      const preferred=this.dataset.defaultGender ?? 'Women';
      this.fit = this.products.some(p=>p.fit===preferred) ? preferred : ''; this.size = '';
      this.slots = Array.from({length:3}, () => ({product:null,variant:null,fit:''}));
      this.count = Number(this.dataset.default) || 1;
      this.busy = false;
      this.form = this.querySelector('form');
      this.status = this.querySelector('[data-status]');
      this.button = this.querySelector('[type=submit]');
      this.buttonLabel = this.button.querySelector('[data-atc-label]') || this.button;
      this.originalButton = this.buttonLabel.textContent;
      this.addEventListener('change', event => {
        if (event.target.type === 'radio' && event.target.closest('[data-tier]')) { this.count = Number(event.target.value); this.render(); }
      });
      this.form.addEventListener('submit', event => {event.preventDefault(); this.submit();});
      this.render();
    }
    gender(value) {
      const text=String(value || '').toLowerCase();
      if(/\b(women|womens|woman|female|ladies)\b/.test(text))return 'Women';
      if(/\b(men|mens|man|male)\b/.test(text))return 'Men';
      return '';
    }
    collectionProducts(products) {
      return products.flatMap(product=>{
        const genderIndex=(product.options || []).findIndex(name=>/^(gender|fit|sex)$/i.test(name));
        const colorIndex=(product.options || []).findIndex(name=>/^(colou?r|pattern|style)$/i.test(name));
        const tags=(product.tags || []).map(tag=>String(tag).toLowerCase());
        const female=tags.some(tag=>/^(women|womens|women's|female|gender:women|gender:female)$/.test(tag));
        const male=tags.some(tag=>/^(men|mens|men's|male|gender:men|gender:male)$/.test(tag));
        const baseGender=female !== male ? (female?'Women':'Men') : this.gender(product.title+' '+product.handle);
        const groups=new Map();
        product.variants.forEach(variant=>{
          const fit=genderIndex>=0 ? this.gender(variant.options?.[genderIndex]) : baseGender;
          if(!fit)return;
          const style=colorIndex>=0 ? variant.options?.[colorIndex] : product.title.split(/\s[-–]\s/).pop();
          const key=fit+'|'+style;
          if(!groups.has(key))groups.set(key,{...product,id:String(product.id)+'|'+key,fit,style:style || product.title,variants:[],image:variant.image || product.image,images:variant.image?[{src:variant.image,alt:product.title},...product.images.filter(image=>image.src!==variant.image)]:product.images});
          groups.get(key).variants.push(variant);
        });
        return Array.from(groups.values());
      });
    }
    money(cents) { return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.dataset.currency || 'USD'}).format(cents/100); }
    discount(n) { return n === 2 ? Number(this.dataset.two) : n === 3 ? Number(this.dataset.three) : 0; }
    price(n) {
      const base = this.products[0]?.variants[0]?.price || 5999;
      return this.slots.slice(0,n).reduce((sum,s) => sum + (s.product?.variants.find(v=>v.id === s.variant)?.price ?? s.product?.variants[0]?.price ?? base),0);
    }
    select(label,values,value,change) {
      const wrap = document.createElement('label');wrap.textContent=label;
      const select=document.createElement('select'); select.setAttribute('aria-label',label);
      const empty=new Option('Choose '+label.toLowerCase(),''); select.add(empty);
      values.forEach(v=>{const o=new Option(v.label,String(v.value));o.disabled=!!v.disabled;select.add(o);});
      select.value=value || '';select.addEventListener('change',()=>change(select.value));wrap.append(select);return wrap;
    }
    renderGallery(product) {
      this.querySelector('[data-product-title]').textContent=product?.title || 'Insulated Winter Gloves';
      if(this.galleryInitialized && this.galleryProduct===product) return;
      this.galleryInitialized=true;
      this.galleryProduct=product;
      const main=this.querySelector('[data-gallery-main]'),thumbs=this.querySelector('[data-gallery-thumbs]');
      main.replaceChildren();thumbs.replaceChildren();
      const images=product?.images || [];
      let current=0;
      const show=(index)=>{
        current=index;
        const img=document.createElement('img');img.src=images[index].src;img.alt=images[index].alt || product.title;img.width=1000;img.height=1000;main.replaceChildren(img);
        thumbs.querySelectorAll('button').forEach((b,i)=>{b.setAttribute('aria-pressed',String(i===index));if(i===index)b.scrollIntoView({block:'nearest',inline:'nearest'});});
      };
      images.forEach((image,index)=>{
        const button=document.createElement('button');button.type='button';button.setAttribute('aria-label','View product image '+(index+1));
        const img=document.createElement('img');img.src=image.src;img.alt='';img.loading='lazy';img.width=64;img.height=64;button.append(img);button.addEventListener('click',()=>show(index));thumbs.append(button);
      });
      const prev=this.querySelector('[data-gallery-prev]'),next=this.querySelector('[data-gallery-next]');
      prev.hidden=next.hidden=images.length<2;
      prev.onclick=()=>show((current-1+images.length)%images.length);
      next.onclick=()=>show((current+1)%images.length);
      let startX=0;
      main.ontouchstart=event=>{startX=event.changedTouches[0].clientX;};
      main.ontouchend=event=>{const delta=event.changedTouches[0].clientX-startX;if(images.length>1 && Math.abs(delta)>45)show((current+(delta<0?1:-1)+images.length)%images.length);};
      if(images.length) show(0);
    }
    choices(label,values,value,change,images=false) {
      const field=document.createElement('fieldset');field.className='fdw-choice-field';
      const legend=document.createElement('legend');legend.textContent=label;field.append(legend);
      const list=document.createElement('div');list.className=images?'fdw-swatches':'fdw-option-buttons';
      values.forEach(v=>{const button=document.createElement('button');button.type='button';button.className='fdw-option';button.disabled=!!v.disabled;button.setAttribute('aria-pressed',String(String(v.value)===String(value)));button.setAttribute('aria-label',v.label);
        if(images && v.image){const img=document.createElement('img');img.src=v.image;img.alt='';img.width=72;img.height=72;button.append(img);}
        const text=document.createElement('span');text.textContent=v.label;button.append(text);button.addEventListener('click',()=>change(String(v.value)));list.append(button);
      });field.append(list);return field;
    }
    variantSize(product,variant) {
      const index=(product.options || []).findIndex(name=>/size/i.test(name));
      return index>=0 ? variant.options?.[index] : variant.title;
    }
    render() {
      const guide=this.querySelector('.fdw-size-guide');
      if(guide)guide.remove();
      const globals=this.querySelector('[data-global-options]');globals.replaceChildren();
      const fits=['Women','Men'].filter(fit=>this.products.some(p=>p.fit===fit));
      globals.append(this.choices('Gender',fits.map(f=>({value:f,label:f+"'s"})),this.fit,value=>{this.fit=value;this.size='';this.slots.forEach(s=>{s.product=null;s.variant=null;});this.render();}));
      const products=this.products.filter(p=>p.fit===this.fit);
      const sizes=[...new Set(products.flatMap(p=>p.variants.map(v=>this.variantSize(p,v))))].filter(Boolean);
      const order=['xs','extra small','s','small','m','medium','l','large','xl','x-large','extra large','xxl','2xl'];
      sizes.sort((a,b)=>{const rank=v=>{const i=order.indexOf(v.toLowerCase());return i<0?order.length:i;};return rank(a)-rank(b) || a.localeCompare(b);});
      const colors=this.size ? products.filter(p=>p.variants.some(v=>this.variantSize(p,v)===this.size)) : products;
      const sizeField=this.choices('Size',sizes.map(size=>({value:size,label:size})),this.size,value=>{this.size=value;this.render();});
      if(guide){
        const legend=sizeField.querySelector('legend');
        const link=document.createElement('button');link.type='button';link.className='fdw-size-guide-link';link.textContent=guide.querySelector('summary').textContent;
        guide.id='fdw-size-guide-'+this.closest('section').id;
        link.setAttribute('aria-controls',guide.id);link.setAttribute('aria-expanded',String(guide.open));
        link.addEventListener('click',()=>{guide.open=!guide.open;link.setAttribute('aria-expanded',String(guide.open));});
        legend.append(link);sizeField.insertBefore(guide,sizeField.querySelector('.fdw-option-buttons'));
      }
      globals.append(sizeField);
      this.slots.forEach((s,index)=>{if(!colors.includes(s.product))s.product=index===0 ? colors[0] || null : this.slots[0].product || null;s.variant=s.product?.variants.find(v=>this.variantSize(s.product,v)===this.size)?.id || null;});
      globals.append(this.choices('Color'+(this.slots[0].product ? ': '+this.slots[0].product.style : ''),colors.map(p=>({value:p.id,label:p.style,image:p.image})),this.slots[0].product?.id,value=>{this.slots[0].product=colors.find(p=>String(p.id)===value)||null;this.render();},true));
      this.renderGallery(this.slots[0].product || products[0] || this.products[0]);
      this.querySelectorAll('[data-tier]').forEach(tier=>{
        const n=Number(tier.dataset.tier),active=n===this.count;
        tier.classList.toggle('is-selected',active);tier.querySelector('input').checked=active;
        const total=this.price(n),off=this.discount(n);
        tier.querySelector('[data-price]').textContent=total ? this.money(Math.round(total*(1-off/100))) : this.money(5999*n);
        tier.querySelector('[data-original]').textContent=off && total ? this.money(total) : '';
        tier.querySelector('[data-badge]').textContent=off ? off+'% OFF' : '';
        const pairs=tier.querySelector('[data-pairs]');pairs.hidden=!active;pairs.replaceChildren();
        if (!active || n===1) return;
        this.slots.slice(0,n).forEach((s,i)=>{
          const row=document.createElement('div');row.className='fdw-pair';
          const title=document.createElement('strong');title.textContent='PAIR '+(i+1);row.append(title);
          if (s.product?.image) {const img=document.createElement('img');img.src=s.product.image;img.alt=s.product.style;img.width=64;img.height=64;row.append(img);}
          const fields=document.createElement('div');fields.className='fdw-fields';
          fields.append(this.select('Color',colors.map(p=>({value:p.id,label:p.style})),s.product?.id,value=>{s.product=this.products.find(p=>String(p.id)===value)||null;this.render();}));
          row.append(fields);pairs.append(row);
        });
      });
      const complete=this.slots.slice(0,this.count).every(s=>s.product && s.product.variants.some(v=>v.id===s.variant && v.available));
      const enabled=this.dataset.enabled==='true' && this.dataset.offers==='true';
      this.button.disabled=this.busy || !complete || !enabled;
      this.buttonLabel.textContent=this.busy ? 'ADDING...' : this.originalButton;
      const preorderPrice=this.querySelector('[data-preorder-price]'),preorderOriginal=this.querySelector('[data-preorder-original]');
      if(preorderPrice)preorderPrice.textContent=this.money(Math.round(this.price(this.count)*(1-this.discount(this.count)/100)));
      if(preorderOriginal)preorderOriginal.textContent=this.discount(this.count) ? this.money(this.price(this.count)) : '';
      if (!this.busy) this.status.textContent=!this.products.length ? (window.Shopify?.designMode ? 'Choose a collection with products labeled Men or Women.' : '') : !complete ? 'Choose your gender, size and colors.' : !enabled ? '' : '';
    }
    async submit() {
      if(this.busy || this.button.disabled) return;
      this.busy=true;this.render();
      const items=this.slots.slice(0,this.count).map((s,i)=>({id:s.variant,quantity:1,properties:{'_FD Winter Bundle':String(this.count),'_FD Pair':String(i+1)}}));
      try {
        const root=window.Shopify?.routes?.root || '/';
        const response=await fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const data=await response.json();if(!response.ok) throw new Error(data.description || data.message || 'Unable to add these gloves. Please try again.');
        // Cart page is the reliable fallback; Shopify applies configured discounts there.
        window.location.assign(root+'cart');
      } catch(error) {this.busy=false;this.render();this.status.textContent=error.message;}
    }
  }
  customElements.define('fd-winter-bundle',WinterBundle);
})();

if (!customElements.get('fd-benefit-strip')) customElements.define('fd-benefit-strip',class extends HTMLElement {
 connectedCallback(){
  const track=this.querySelector('[data-benefit-track]');
  if(track.dataset.cloned)return;
  track.dataset.cloned='true';
  const group=document.createElement('div');group.className='fdw-benefit-group';
  while(track.firstChild)group.append(track.firstChild);
  const duplicate=group.cloneNode(true);duplicate.setAttribute('aria-hidden','true');duplicate.classList.add('fdw-benefit-duplicate');
  track.append(group,duplicate);
 }
});

if(!customElements.get('fd-rotating-phrase'))customElements.define('fd-rotating-phrase',class extends HTMLElement{
 connectedCallback(){
  this.phrases=JSON.parse(this.querySelector('[data-phrases]').textContent).filter(Boolean);this.index=0;this.paused=false;
  const hero=this.closest('.fdw-background-hero'),video=hero.querySelector('video');
  const reduced=matchMedia('(prefers-reduced-motion:reduce)').matches;
  if(reduced){this.paused=true;video?.pause();}
  this.timer=setInterval(()=>{if(this.paused || document.hidden || !this.phrases.length)return;this.index=(this.index+1)%this.phrases.length;this.querySelector('[data-phrase]').textContent=this.phrases[this.index];},Number(this.dataset.seconds)*1000 || 3000);
 }
 disconnectedCallback(){clearInterval(this.timer);}
});